export class Constants {
  static Cookies = class Cookies {
    static readonly Hangfire = "CM-Auth-HF";
  }
}
